import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCustomerList as _getCustomerList, getCinemaList as _getCinemaList, getEditCinemaRule, getEditCinemaRuleCustom as _getEditCinemaRuleCustom, getEditCinemaRuleCinema as _getEditCinemaRuleCinema, handChannelWarningRestrictions } from '@/api/goodsCenter';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      activeName: 'custom',
      ruleType: '',
      // 1个性化2影院3客户4全局
      rule_id: '',
      customForm: {
        id: '',
        name: '',
        page: 1,
        page_size: 20
      },
      cinemaForm: {
        cinema_name: '',
        standard_id: '',
        selected_standard_ids: '',
        page: 1,
        pagesize: 20
      },
      // 列表查询参数
      setFormRule: {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        is_show_line_price: '0',
        is_set_timing: '',
        time_type: null,
        day_type: null,
        dayValue: []
      },
      times: [{
        value: ['00:00:00', '23:59:59']
      }],
      days: [{
        name: '周一',
        id: 1
      }, {
        name: '周二',
        id: 2
      }, {
        name: '周三',
        id: 3
      }, {
        name: '周四',
        id: 4
      }, {
        name: '周五',
        id: 5
      }, {
        name: '周六',
        id: 6
      }, {
        name: '周日',
        id: 0
      }],
      tableKey: 0,
      pages: {},
      totalCount: null,
      customList: [],
      checkedCustom: [],
      checkedDelCustom: [],
      checkedCustomList: [],
      checkedCinemaList: [],
      cinemaList: [],
      checkedDelCinema: [],
      warning_restrictions: 0 // 折扣预警值
    };
  },
  computed: {
    priceType: function priceType() {
      if (this.setFormRule.adjust_type.length == 2) {
        return 'all';
      } else if (this.setFormRule.adjust_type.length) {
        if (this.setFormRule.adjust_type[0] == 1) {
          return 'ratio';
        } else {
          return 'money';
        }
      } else {
        return '';
      }
    }
  },
  created: function created() {},
  methods: {
    // 获取折扣预警
    getChannelWarningRestrictions: function getChannelWarningRestrictions() {
      var _this = this;
      handChannelWarningRestrictions().then(function (res) {
        _this.warning_restrictions = Number(res.data.warning_restrictions);
      });
    },
    getEditInfo: function getEditInfo() {
      var _this2 = this;
      // 编辑获取设置影院规则数据
      getEditCinemaRule({
        rule_id: this.rule_id
      }).then(function (res) {
        var data = res.data.data;
        _this2.setFormRule = _objectSpread(_objectSpread({}, data), {}, {
          is_set_timing: Number(data.is_set_timing),
          time_type: data.time_type === null ? null : Number(data.time_type),
          day_type: data.day_type === null ? null : Number(data.day_type),
          dayValue: []
        });
        _this2.times = [];
        if (_this2.setFormRule.is_set_timing == 0) {
          _this2.setFormRule.time_type = null;
          _this2.setFormRule.day_type = null;
          _this2.setFormRule.dayValue = [];
          _this2.times = [{
            value: ['00:00:00', '23:59:59']
          }];
        } else {
          if (_this2.setFormRule.time_type == 1 || _this2.setFormRule.time_type == 0) {
            _this2.times = [{
              value: ['00:00:00', '23:59:59']
            }];
          }
          _this2.setFormRule.dayValue = _this2.setFormRule.day_type == 2 ? (data.day_data && data.day_data.days ? data.day_data.days : []).map(Number) : _this2.days.map(function (item) {
            return item.id;
          });
          if (_this2.setFormRule.time_type == 2) {
            data.time_data.times.forEach(function (e) {
              _this2.times.push({
                value: e
              });
            });
          }
        }
        _this2.dialogVisible = true;
      });
      // 1个性化2影院3客户4全局
      if (this.ruleType == '1') {
        this.activeName = 'custom';
        // 客户数据
        this.getEditCinemaRuleCustom();
        this.getCustomerList();
        // 影院数据
        this.getCinemaList();
        this.getEditCinemaRuleCinema();
      } else if (this.ruleType == '3') {
        this.activeName = 'cinema';
        this.getCinemaList();
        this.getEditCinemaRuleCinema();
      } else if (this.ruleType == '2') {
        this.activeName = 'custom';
        this.getEditCinemaRuleCustom();
        this.getCustomerList();
      }
    },
    // 编辑获取已选客户
    getEditCinemaRuleCustom: function getEditCinemaRuleCustom() {
      var _this3 = this;
      _getEditCinemaRuleCustom({
        rule_id: this.rule_id,
        pagesize: 10000
      }).then(function (res) {
        _this3.checkedCustomList = res.data.data.data;
      });
    },
    getEditCinemaRuleCinema: function getEditCinemaRuleCinema() {
      var _this4 = this;
      _getEditCinemaRuleCinema({
        rule_id: this.rule_id,
        pagesize: 10000
      }).then(function (res) {
        _this4.checkedCinemaList = res.data.data.data;
      });
    },
    // 获取所有影院列表
    getCinemaList: function getCinemaList() {
      var _this5 = this;
      _getCinemaList(this.cinemaForm).then(function (res) {
        _this5.cinemaList = res.data.data.data;
        _this5.totalCount = res.data.data.totalCount;
      });
    },
    // 获取客户列表
    getCustomerList: function getCustomerList() {
      var _this6 = this;
      _getCustomerList(this.customForm).then(function (res) {
        _this6.customList = res.data.list;
        _this6.pages = res.pages;
      });
    },
    // 设置规则弹框 待选择客户table 选中事件
    handleSelectionCustom: function handleSelectionCustom(val, type) {
      if (type == 'custom') {
        this.checkedCustom = val;
      } else {
        this.checkedCinema = val;
      }
    },
    // 设置规则弹框 已选择客户table选中事件
    handleCheckedDelCustom: function handleCheckedDelCustom(val, type) {
      if (type == 'custom') {
        this.checkedDelCustom = val;
      } else {
        this.checkedDelCinema = val;
      }
    },
    // 搜索设置规则里的查询客户
    searchCustom: function searchCustom(type) {
      if (type == 'custom') {
        this.customForm.page = 1;
        this.getCustomerList();
      } else {
        this.cinemaForm.page = 1;
        this.getCinemaList();
      }
    },
    // 设置规则 批量添加客户
    batchAddCustom: function batchAddCustom(type) {
      if (type == 'custom') {
        var _this$checkedCustomLi;
        if (!this.checkedCustom.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCustomLi = this.checkedCustomList).push.apply(_this$checkedCustomLi, _toConsumableArray(this.checkedCustom));
        this.$refs.multipleTable.clearSelection();
      } else {
        var _this$checkedCinemaLi;
        this.tableKey++;
        if (!this.checkedCinema.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCinemaLi = this.checkedCinemaList).push.apply(_this$checkedCinemaLi, _toConsumableArray(this.checkedCinema));
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 批量删除客户
    batchDel: function batchDel(type) {
      var _this7 = this;
      if (type == 'custom') {
        this.checkedDelCustom.forEach(function (item) {
          var index = _this7.checkedCustomList.indexOf(item);
          if (index !== -1) {
            _this7.checkedCustomList.splice(index, 1);
          }
        });
      } else {
        this.checkedDelCinema.forEach(function (item) {
          var index = _this7.checkedCinemaList.indexOf(item);
          if (index !== -1) {
            _this7.checkedCinemaList.splice(index, 1);
          }
        });
      }
    },
    // 待选择客户的禁用选项框条件
    selectableCustom: function selectableCustom(row) {
      var flag = true;
      this.checkedCustomList.forEach(function (e) {
        if (e.id == row.id) {
          flag = false;
        }
      });
      return flag;
    },
    // 待选择影院的禁用选项框条件
    selectableCinema: function selectableCinema(row) {
      var flag = true;
      this.checkedCinemaList.forEach(function (e) {
        if (e.standard_id == row.standard_id) {
          console.log(12312313);
          flag = false;
        }
      });
      return flag;
    },
    editSubmitAdjust: function editSubmitAdjust() {
      var _this8 = this;
      this.$refs.setFormRule.validate(function (valid) {
        if (valid) {
          _this8.$confirm('为防止规则冲突，本公司用户不允许绑其他公司卡，不允许纯微信支付；系统自动完成相关开关的设置！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(function () {
            if (_this8.setFormRule.time_type == 2) {
              var timeIds = _this8.times.map(function (item) {
                return item.value;
              });
            }
            if (_this8.setFormRule.time_type == 2 && _this8.isOverlap(timeIds)) {
              _this8.$message.warning('请检查您选择的时间段是否有重叠');
              return false;
            }
            var day_type = _this8.setFormRule.dayValue.length === 7 ? 1 : 2;
            var params = _objectSpread(_objectSpread({}, _this8.setFormRule), {}, {
              day_type: day_type,
              times: timeIds,
              days: _this8.setFormRule.dayValue,
              selected_company_info: [],
              selected_standard_ids: [],
              type: 'edit'
            });
            if (_this8.ruleType == 1) {
              params.selected_company_info = _this8.checkedCustomList.map(function (i) {
                return {
                  company_name: i.company_name,
                  id: i.id
                };
              });
              params.selected_standard_ids = _this8.checkedCinemaList.map(function (i) {
                return i.standard_id;
              });
            } else if (_this8.ruleType == 3) {
              params.selected_standard_ids = _this8.checkedCinemaList.map(function (i) {
                return i.standard_id;
              });
              params.selected_company_info = -1;
            } else if (_this8.ruleType == 2) {
              params.selected_company_info = _this8.checkedCustomList.map(function (i) {
                return {
                  company_name: i.company_name,
                  id: i.id
                };
              });
              params.selected_standard_ids = -1;
            } else if (_this8.ruleType == 4) {
              params.selected_company_info = -1;
              params.selected_standard_ids = -1;
            }
            _this8.$emit('editSubmitAdjust', params);
          }).catch(function () {});
        }
      });
    },
    // 校验时间是否有重叠
    isOverlap: function isOverlap(timeRanges) {
      // 将时间字符串转换为可以比较的数值
      var ranges = timeRanges.map(function (range) {
        return range.map(function (time) {
          var _time$split = time.split(':'),
            _time$split2 = _slicedToArray(_time$split, 3),
            hour = _time$split2[0],
            minute = _time$split2[1],
            second = _time$split2[2];
          return hour * 3600 + minute * 60 + second * 1;
        });
      });

      // 检查是否有任何范围与其他范围重叠
      for (var i = 0; i < ranges.length; i++) {
        for (var j = i + 1; j < ranges.length; j++) {
          if (ranges[i][0] < ranges[j][1] && ranges[j][0] < ranges[i][1]) {
            return true;
          }
        }
      }
      return false;
    },
    // 分页操作
    onChange: function onChange(val, type) {
      if (type == 'cinema') {
        this.cinemaForm.page = val;
        this.getCinemaList();
      } else if (type == 'custom') {
        this.customForm.page = val;
        this.getCustomerList();
      }
    },
    sizeChange: function sizeChange(val, type) {
      // this.form.pagesize = val
      if (type == 'cinema') {
        this.cinemaForm.pagesize = val;
        this.getCinemaList();
      } else if (type == 'custom') {
        this.customForm.page_size = val;
        this.getCustomerList();
      }
    },
    closeDialog: function closeDialog() {
      this.setFormRule = {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        is_set_timing: '',
        time_type: null,
        day_type: null,
        dayValue: []
      };
      this.times = [{
        value: ['00:00:00', '23:59:59']
      }];
      this.activeName = 'custom';
      this.customForm = {
        name: '',
        id: ''
      };
      if (this.ruleType != 4) this.$refs.multipleTable.clearSelection();
      this.checkedCustomList = [];
      this.checkedDelCustom = [];
    },
    addTime: function addTime() {
      this.times.push({
        value: ['00:00:00', '23:59:59']
      });
    },
    delTime: function delTime(index) {
      this.times.splice(index, 1);
    }
  }
};